import React from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'

import { useMarketplace } from '@src/hooks/useMarketplace'

// Outlet ids are CUIDs (>= 20 alphanumerics, no hyphens); merchant slugs are
// hyphenated words. Universal links can arrive with the two segments in either
// order, so normalise to the canonical /{urlPath}/{outletId}/{merchant}.
const looksLikeOutletId = (value?: string): boolean =>
  !!value && /^[a-z0-9]{20,}$/i.test(value)

export const CanonicalOutletOrderRedirect: React.FC = ({ children }) => {
  const { urlPath } = useMarketplace()
  const { outletId, merchantName, '*': rest } = useParams()
  const location = useLocation()

  const segmentsAreSwapped =
    !looksLikeOutletId(outletId) && looksLikeOutletId(merchantName)

  if (segmentsAreSwapped) {
    const restPath = rest ? `/${rest}` : ''

    return (
      <Navigate
        replace
        to={`/${urlPath}/${merchantName}/${outletId}${restPath}${location.search}`}
      />
    )
  }

  return <>{children}</>
}
